import { render, staticRenderFns } from "./linkinvalid.vue?vue&type=template&id=cd46d4d2&scoped=true&"
import script from "./linkinvalid.vue?vue&type=script&lang=ts&"
export * from "./linkinvalid.vue?vue&type=script&lang=ts&"
import style0 from "./linkinvalid.vue?vue&type=style&index=0&id=cd46d4d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd46d4d2",
  null
  
)

export default component.exports